import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TableCell, TableRow, Typography } from '@mui/material';

import { getProvidersOutstandingRequest } from '../../../store/OutstandingBalance/actions'
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import { renderTextEllipsis, setPageMainTitle, textContainOnlySpaces } from "../../../utils/Helpers";
import { ViewBgIcon } from '../../../utils/Icons';
import messages from '../../../assets/locale/messages';
import SearchInput from '../../../components/SearchInput';
import EmptyState from '../../../components/EmptyState';
import Table from '../../../components/Table';
import Pagination from '../../../components/Pagination';
import './OutstandingBalance.scss'

const OutstandingBalance = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const isLoading = useSelector((state) => state.loader);
    const outstadingBalanceList = useSelector((state) => state.outstandingBalance.list);
    const meta = useSelector((state) => state.outstandingBalance.meta);
    const { outStandingBalance, shared } = messages[lang];
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(1);

    useEffect(() => {
        setPageMainTitle('settlementsManagement');
        getProvidersOutstadingBalanceList(1,searchValue)
    }, []);

    useEffect(() => {
        getProvidersOutstadingBalanceList(page,searchValue)
    }, [page]);

    useEffect(() => {
        if ((searchValue.length >= 3 || searchValue.length === 0) && !textContainOnlySpaces(searchValue)){
            setPage(1)
            getProvidersOutstadingBalanceList(1,searchValue)
        }
    }, [searchValue]);

    const getProvidersOutstadingBalanceList = (page,search) =>{
        dispatch(getProvidersOutstandingRequest({
            query:search,
            page: page,
            items:10
        }))
    };

    const handleViewDetails = (id) => {
        history.push(ROUTE_PATHS.viewSettlement.replace(':id', id))
    };

    const renderHeaderSection = (showActions) => (
        <>
        <div className="header-section mb-5">
          <div className="title-search d-flex gap-2">
            <Typography
              variant="h4"
              sx={{ flexGrow: 1 }}
              className={`page-title flex-grow-0 ${lang === 'en' ? 'me-3' : 'ms-3'}`}>
              {outStandingBalance.list.providersOutstandingBalance}
            </Typography>
            {showActions && (
              <SearchInput
                className="filter-label-wrapper"
                placeholder={outStandingBalance.list.searchPlaceholder}
                name="search"
                value={searchValue}
                onChange={(value) => {
                  setSearchValue(value);
                }}
              />
            )}
          </div>
        </div>
      </>
    );

    const renderProvidersOutstandingList = () => {
        if(!isLoading &&
            outstadingBalanceList?.length === 0 &&
           !searchValue   
          ){
            return (
              <>
                {renderHeaderSection(false)}
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column">
                  <EmptyState
                    subTitle={shared.noData}
                    showActionButton={false}
                    NoDataListWithNoActionBtn={true}
                  />
                </div>
              </>
            );
          } else if (
            !isLoading &&
            searchValue  &&
            outstadingBalanceList?.length === 0
          ){
            return(
              <>
                {renderHeaderSection(true)}
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column  mt-3">
                  <EmptyState subTitle={shared.noSearch} showActionButton={false} />
                </div>
              </>
            );
          } else {
            return(
              <>    
                <div className="outStanding-page">
                  {renderHeaderSection(true)}
                  <div className="bg-white rounded-4 my-3 outStanding-table-list">
                    <Table
                      headlines={[
                        outStandingBalance.list.providerNumber,
                        outStandingBalance.list.providerName,
                        outStandingBalance.list.outstandingBalance,
                      ]}
                      hasActions={true}
                      rows={outstadingBalanceList?.map((row, i) => (
                        <TableRow key={i}>
                          {/* Provider number */}
                          <TableCell className="font-regular text-dark-blue fsize-14">
                            {row.service_provider_number}
                          </TableCell>
                          {/* Provider name */}
                          <TableCell className="font-regular text-dark-blue fsize-14 ">
                            {lang === "en"
                              ? renderTextEllipsis(row.name_en) 
                              : renderTextEllipsis(row.name_ar)
                            }
                          </TableCell>
                          {/* Outstanding balance */}
                          <TableCell className="font-regular text-dark-blue fsize-14 ">
                            {row.outstanding_balance}
                          </TableCell>
                          <TableCell className="font-regular text-dark-blue fsize-14 ">
                              <ViewBgIcon
                                className="pointer"
                                onClick={() => handleViewDetails(row.id)}
                              />
                          </TableCell>
                        </TableRow>
                      ))}
                    />
                    <div className="d-flex justify-content-center py-3">
                      {meta?.pages > 1 && (
                        <Pagination
                          count={meta?.pages}
                          page={meta?.currentPage || page}
                          handleChange={(event, page) => {
                          setPage(page);
                           }}
                          defaultPage={1}
                        />
                      )} 
                    </div>
                  </div>
                </div>                 
              </>
            );
          }
      }

    return (renderProvidersOutstandingList())
};

export default OutstandingBalance;